<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="推广者编号：" prop="member_code">
                <el-input v-model="model.member_code" disabled></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
                <el-input v-model="model.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <el-input v-model="model.cellphone" disabled></el-input>
            </el-form-item>
            <el-form-item label="结算金额：">
                <el-input v-model="balance_ready" disabled></el-input>
            </el-form-item>
            <el-form-item label="校验金额：">
                <el-input v-model="balance_ready1" disabled></el-input>
            </el-form-item>
            <el-form-item label="结算订单数：">
                <el-input v-model="order_ready" disabled></el-input>
            </el-form-item>
            <el-form-item label="校验订单数：">
                <el-input v-model="order_ready1" disabled></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark" type="textarea" rows="4" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="上传凭证：" prop="evidence">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload">
                    <img v-if="model.evidence" :src="model.evidence" class="upImg" style="width: 240px;height: 240px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 240px;height: 240px;line-height: 240px"></i>
                </el-upload>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel, getModelById } from '@/api/common'
import { settedInfo } from '@/api/promotiondao'
import config from '@/config'

export default {
    name: 'promotionSettledEdit',
    mixins: [editutil],
    props: {
        member_id: {
            type: Number,
            default() {
                return -1;
            }
        },
    },
    data() {
        return {
            model: {
                member_id: '',
                member_code: '',
                name: '',
                cellphone: '',
                batch: '',
                monty: '',
                settled_time: '',
                creator: '',
                creator_name: '',
                evidence: '',
            },
            balance_ready: 0,
            balance_ready1: 0,
            order_ready: 0,
            order_ready1: 0,
            getObj:{
                url:'/api/admin/promotionsettled/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                evidence: [
                    {required: true, message: '请上传凭证', trigger: 'blur'}
                ],
            },
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "settled",
            },
        };
    },
    methods: {
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.member_id > 0) {
                settedInfo(this.member_id).then(res => {
                    if (res.code === 1) {
                        this.model.member_id = res.data.member_id
                        this.model.member_code = res.data.member_code
                        this.model.name = res.data.name
                        this.model.cellphone = res.data.cellphone
                        this.balance_ready = res.data.balance_ready
                        this.balance_ready1 = res.data.balance_ready1
                        this.order_ready = res.data.order_ready
                        this.order_ready1 = res.data.order_ready1
                    } else {
                        this.$msg(res.msg)
                    }
                })
            }
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/promotionsettled/settled'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                this.model.evidence = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
    }
};
</script>